import Repository, {
  ExtendedAxiosRequestConfig,
} from "@shared/services/api/abstracts/Repository";
import { PublicBaseLocationPermissionsV2Serializer } from "../types/seating-types";

export default class PublicBasedTTLocationPermissionsV2Repository extends Repository<PublicBaseLocationPermissionsV2Serializer> {
  public readonly repositoryName =
    "PublicBasedTTLocationPermissionsV2Repository";

  public readonly endpoint =
    "/api/public/events/ticket-types/location-permissions/v2/";

  public async getPermissions(config: ExtendedAxiosRequestConfig) {
    const { data } = await this.request(this.buildUrl(), config);
    return data;
  }
}
